import { useState, useEffect, useCallback, useRef } from "react";
import { makeRequest } from "../../../../assets/functions_helper";
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  Grid,
  IconButton,
  Container,
  MenuItem,
  Drawer,
  Snackbar,
  Alert,
  TextField,
  DialogContentText,
  Divider,
  Badge,
  Menu,
  Slide,
  DialogContent,
  Dialog,
  Autocomplete,
  Avatar,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import { useParams } from "react-router-dom";
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import imagenLocal from "../../../../assets/images/sections.jpg";
import { ProductCard, OrderProductCard } from "../menu_clients/cards";
import { WorldCupRenderer } from "../menu_clients/world_cup_templates/WorldCupRenderer";
import { WorldCupProductModal } from "../menu_clients/world_cup_templates/WorldCupProductModal";
import { worldCupThemeAssets } from "../menu_clients/world_cup_templates/themeAssets";
import { initGoogleAnalytics } from "../../../../assets/analytics_helper";
import MyLocationIcon from '@mui/icons-material/MyLocation';
import AddressMapSelector from './AddressMapSelector';
import PromotionalBannerModal from "../../../../components/PromotionalBannerModal";

import {
  CustomDialog,
  CustomDialogTitle,
  CustomDialogContent,
  CustomDialogActions
} from "../../../../components/customDialog";

// Utilidad para convertir hex a rgb (para sombras)
function hexToRgb(hex) {
  hex = hex.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return `${r}, ${g}, ${b}`;
}

// Función para obtener color de contraste (blanco o negro) dado un color de fondo
const getContrastColor = (hex) => {
  if (!hex) return '#ffffff';
  const luma = (() => {
    const c = hex.substring(1);
    const rgb = parseInt(c, 16);
    const r = (rgb >> 16) & 0xff;
    const g = (rgb >> 8) & 0xff;
    const b = (rgb >> 0) & 0xff;
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
  })();
  return luma > 160 ? '#000000' : '#ffffff';
};

// --- HEADER PRINCIPAL (no sticky) ---
const MenuHeader = ({
  menuSections,
  sessionCode,
  onScrollToSection,
  menuConfig,
  logoUrl,
  nameMenu
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedSection, setSelectedSection] = useState("Todo el menú");
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (sectionName) => {
    setAnchorEl(null);
    if (sectionName) {
      setSelectedSection(sectionName);
      onScrollToSection(sectionName);
    }
  };

  return (
    <Box sx={{
      px: { xs: 2, sm: 3 },
      py: 2,
      backgroundColor: menuConfig.header?.background_color || (menuConfig.darkMode ? "#1E1E1E" : "#FFFFFF"),
      borderBottom: menuConfig.darkMode ? '1px solid rgba(255,255,255,0.05)' : '1px solid rgba(0,0,0,0.05)',
    }}>
      {/* Fila superior: logo y código de mesa */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {/* Logo siempre visible con placeholder */}
          <Box
            component="img"
            src={logoUrl || 'https://lh3.googleusercontent.com/aida-public/AB6AXuA6hR82T0AyZSauL044UIYESTK5raRF8lCbtjl6ErjHlqMAd8BiWBKyoeAPV9GlNRrvCwWBDfQOtEZuwaqAGFXYQYSOCTf_U-3YIurTaDdGxZl7gStyZ0iJXCPaJ462zDozm7Z4nJx3JIZ3GJeCr2COM9eH_XAPNt83_8R76ghqMC33jIUtNS5x-c9gYs198vQ1St_kDPGbkyrFzYwUwom5XMlZx8r8qnEeaZ7XKuNFvYwTJrtFIXI-eq2Hd3O9NAe9GsFHD4hcyyY'}
            alt="Logo"
            sx={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              objectFit: 'cover',
              border: menuConfig.darkMode ? '2px solid rgba(255,255,255,0.1)' : '2px solid rgba(0,0,0,0.05)'
            }}
          />
          <Box>
            <Typography variant="caption" sx={{
              color: menuConfig.darkMode ? '#AAAAAA' : '#666666',
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '1px',
              fontSize: '0.65rem'
            }}>
              Bienvenido
            </Typography>
            <Typography variant="body1" sx={{
              fontWeight: 700,
              color: menuConfig.header?.text_color || (menuConfig.darkMode ? '#FFFFFF' : '#1A1A1A'),
              fontSize: '1rem'
            }}>
              {nameMenu}
            </Typography>
          </Box>
        </Box>

        {sessionCode && (
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            backgroundColor: menuConfig.tableCode?.background_color || (menuConfig.darkMode ? "rgba(197, 160, 89, 0.1)" : "rgba(197, 160, 89, 0.08)"),
            padding: '6px 16px',
            borderRadius: '50px',
            border: `1px solid ${menuConfig.tableCode?.border_color || "#C5A059"}`,
          }}>
            <Typography variant="caption" sx={{
              color: menuConfig.tableCode?.label_color || (menuConfig.darkMode ? '#AAAAAA' : '#666666'),
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '1px',
              fontSize: '0.65rem'
            }}>
              Mesa
            </Typography>
            <Typography variant="h6" sx={{
              color: menuConfig.tableCode?.number_color || "#C5A059",
              fontWeight: 900,
              fontSize: '1.25rem',
              lineHeight: 1
            }}>
              {sessionCode}
            </Typography>
          </Box>
        )}
      </Box>

      {/* Botón selector de categorías */}
      <Box>
        <Button
          variant="outlined"
          fullWidth
          startIcon={<RestaurantMenuIcon />}
          endIcon={<ExpandMoreIcon />}
          onClick={handleClick}
          sx={{
            justifyContent: 'space-between',
            backgroundColor: menuConfig.filter?.background_color || (menuConfig.darkMode ? '#2A2A2A' : '#F5F5F5'),
            color: menuConfig.filter?.text_color || (menuConfig.darkMode ? '#FFFFFF' : '#1A1A1A'),
            borderColor: menuConfig.darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
            borderRadius: '16px',
            textTransform: 'none',
            fontWeight: 600,
            py: 1.5,
            px: 3,
            '&:hover': {
              borderColor: menuConfig.darkMode ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
              backgroundColor: menuConfig.filter?.background_color || (menuConfig.darkMode ? '#2A2A2A' : '#F5F5F5'),
              transform: 'translateY(-2px)'
            }
          }}
        >
          {selectedSection}
        </Button>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={() => handleClose()}
          PaperProps={{
            sx: {
              borderRadius: '16px',
              mt: 1,
              boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
              '& .MuiMenuItem-root': {
                fontWeight: 600,
                '&:hover': {
                  backgroundColor: '#f5f5f5'
                },
                '&.Mui-selected': {
                  backgroundColor: menuConfig.filter?.background_color || '#f0f0f0',
                  color: menuConfig.filter?.text_color || '#000'
                }
              }
            }
          }}
        >
          <MenuItem onClick={() => handleClose("Todo el menú")}>Todo el menú</MenuItem>
          {menuSections.map((s) => (
            <MenuItem key={s.name} onClick={() => handleClose(s.name)}>{s.name}</MenuItem>
          ))}
        </Menu>
      </Box>
    </Box>
  );
};

// --- MINI HEADER FLOTANTE (solo select) ---
const MiniHeader = ({ menuSections, onScrollToSection, menuConfig, show }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedSection, setSelectedSection] = useState("Todo el menú");
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (sectionName) => {
    setAnchorEl(null);
    if (sectionName) {
      setSelectedSection(sectionName);
      onScrollToSection(sectionName);
    }
  };

  return (
    <Slide direction="down" in={show} mountOnEnter unmountOnExit>
      <Box sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1200,
        backgroundColor: menuConfig.darkMode ? 'rgba(30,30,30,0.9)' : 'rgba(255,255,255,0.9)',
        backdropFilter: 'blur(10px)',
        borderBottom: menuConfig.darkMode ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(0,0,0,0.05)',
        px: { xs: 2, sm: 3 },
        py: 1.5,
        minHeight: '70px',
        display: 'flex',
        alignItems: 'center'
      }}>
        <Container maxWidth="md" sx={{ px: 0 }}>
          <Button
            variant="outlined"
            fullWidth
            startIcon={<RestaurantMenuIcon />}
            endIcon={<ExpandMoreIcon />}
            onClick={handleClick}
            sx={{
              justifyContent: 'space-between',
              backgroundColor: menuConfig.filter?.background_color || (menuConfig.darkMode ? '#2A2A2A' : '#F5F5F5'),
              color: menuConfig.filter?.text_color || (menuConfig.darkMode ? '#FFFFFF' : '#1A1A1A'),
              borderColor: menuConfig.darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
              borderRadius: '16px',
              textTransform: 'none',
              fontWeight: 600,
              py: 1.2,
              px: 2.5,
              '&:hover': {
                borderColor: menuConfig.darkMode ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
                backgroundColor: menuConfig.filter?.background_color || (menuConfig.darkMode ? '#2A2A2A' : '#F5F5F5'),
              }
            }}
          >
            {selectedSection}
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={() => handleClose()}
            PaperProps={{
              sx: {
                borderRadius: '16px',
                mt: 1,
                boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
                '& .MuiMenuItem-root': {
                  fontWeight: 600,
                  '&:hover': {
                    backgroundColor: '#f5f5f5'
                  },
                  '&.Mui-selected': {
                    backgroundColor: menuConfig.filter?.background_color || '#f0f0f0',
                    color: menuConfig.filter?.text_color || '#000'
                  }
                }
              }
            }}
          >
            <MenuItem onClick={() => handleClose("Todo el menú")}>Todo el menú</MenuItem>
            {menuSections.map((s) => (
              <MenuItem key={s.name} onClick={() => handleClose(s.name)}>{s.name}</MenuItem>
            ))}
          </Menu>
        </Container>
      </Box>
    </Slide>
  );
};

// --- SECCIÓN DEL MENÚ (igual que PreviewSection) ---
const MenuSection = ({ section, onProductSelect, isDarkMode, globalButtonColor }) => {
  const cardType = section.section_type || "default";
  const productBg = isDarkMode ? "#1E1E1E" : "#FFFFFF";
  const productText = isDarkMode ? "#FFFFFF" : "#1A1A1A";
  const buttonColor = section.styles?.buttons_color || globalButtonColor;
  const sectionBackgroundImage = section.background_image_url || imagenLocal;

  return (
    <Box sx={{ mb: 6, px: { xs: 0, sm: 0.5, md: 1 } }}>
      <Box sx={{
        position: 'relative',
        height: '180px',
        borderRadius: '24px',
        overflow: 'hidden',
        mb: 4,
        boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
        '&:hover': { transform: 'scale(1.01)', transition: 'transform 0.3s' }
      }}>
        <Box sx={{
          position: 'absolute',
          inset: 0,
          backgroundImage: `url(${sectionBackgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          zIndex: 1,
          filter: 'brightness(0.8)'
        }} />
        <Box sx={{
          position: 'absolute',
          inset: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          zIndex: 2
        }} />

        <Box sx={{
          position: 'relative',
          zIndex: 3,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          pl: 4,
          pr: 2
        }}>
          <Typography variant="h4" sx={{
            fontWeight: 900,
            color: '#FFFFFF',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            mb: 1
          }}>
            {section.name}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box sx={{ width: '32px', height: '3px', bgcolor: buttonColor || '#C5A059', borderRadius: '2px' }} />
            <Typography variant="caption" sx={{
              color: 'rgba(255,255,255,0.9)',
              fontWeight: 800,
              textTransform: 'uppercase',
              letterSpacing: '1px'
            }}>
              {section.products.length} {section.products.length === 1 ? 'Plato' : 'Platos'}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Grid container spacing={{ xs: 1, sm: 1.5, md: 2 }} sx={{ px: 0 }}>
        {section.products.map((product) => {
          // Determinar qué componente de tarjeta usar basado en si el producto tiene imagen
          const CardComponent = !product.image_url
            ? OrderProductCard               // Sin imagen → tarjeta de solo texto
            : cardType === "default"
              ? ProductCard                     // Con imagen y sección tipo default → tarjeta con imagen
              : OrderProductCard;                // Con imagen pero sección tipo Order → tarjeta solo texto (porque el tipo lo exige)

          return (
            <Grid item xs={12} sm={6} key={product.product_id || product.id}>
              <Box sx={{
                "& .MuiCard-root": {
                  backgroundColor: `${productBg} !important`,
                  boxShadow: `0 8px 20px rgba(0,0,0,0.12), 0 4px 12px ${buttonColor}80 !important`,
                  color: `${productText} !important`,
                  borderRadius: '20px !important',
                  '&:hover': {
                    transform: 'translateY(-4px) !important',
                    boxShadow: '0 8px 30px rgba(0,0,0,0.15) !important'
                  }
                },
                "& .MuiTypography-root": { color: `${productText} !important` },
                "& .MuiTypography-caption": {
                  color: `${isDarkMode ? '#AAAAAA' : '#666666'} !important`,
                  opacity: 0.8
                },
                "& .price-text": {
                  color: `${buttonColor} !important`,
                  fontWeight: 900,
                  fontSize: '1.2rem'
                },
                "& .MuiIconButton-root": {
                  backgroundColor: `${buttonColor} !important`,
                  color: `${getContrastColor(buttonColor)} !important`,
                  borderRadius: '12px !important',
                  width: '40px !important',
                  height: '40px !important',
                  '&:hover': {
                    backgroundColor: `${buttonColor} !important`,
                    opacity: 0.9
                  }
                }
              }}>
                <CardComponent
                  product={product}
                  onSelect={() => onProductSelect(product, section)}
                  buttonColorCards={buttonColor}
                  backgroundColorCards={productBg}
                  textColorCards={productText}
                />
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

const MenuFooter = ({ cart, onOpenCart, menuConfig }) => {
  const totalItems = cart.reduce((total, item) => total + item.quantity, 0);
  const totalPrice = cart.reduce((acc, curr) => acc + (curr.price * curr.quantity), 0);
  const viewCartBg = menuConfig.footer?.view_cart_button_background || "#C5A059";
  const viewCartText = menuConfig.footer?.view_cart_button_text_color || "#ffffff";

  return (
    <Box sx={{
      position: 'sticky',
      bottom: 'calc(20px + env(safe-area-inset-bottom, 0px))',
      left: 0,
      right: 0,
      zIndex: 1100,
      display: 'flex',
      justifyContent: 'center',
      px: { xs: 1, sm: 2, md: 3 },
      mb: 1,
    }}>
      <Box sx={{
        width: '100%',
        maxWidth: 640,
        borderRadius: '20px',
        boxShadow: '0 -4px 20px rgba(0,0,0,0.15)',
        backgroundColor: menuConfig.darkMode ? 'rgba(30, 30, 30, 0.92)' : 'rgba(255, 255, 255, 0.92)',
        backdropFilter: 'blur(20px)',
        border: menuConfig.darkMode ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(0,0,0,0.05)',
        py: 1,
        px: { xs: 2, sm: 3 }
      }}>
        <Button
          variant="contained"
          onClick={onOpenCart}
          disabled={cart.length === 0}
          startIcon={<ShoppingBagIcon />}
          sx={{
            backgroundColor: viewCartBg,
            color: viewCartText,
            borderRadius: '16px',
            px: { xs: 3, sm: 4 },
            py: { xs: 1.5, sm: 2 },
            width: '100%',
            fontWeight: 700,
            textTransform: 'none',
            justifyContent: 'space-between',
            '&:hover': {
              opacity: 0.9,
              transform: 'translateY(-2px)',
              boxShadow: `0 6px 16px ${viewCartBg}60`
            },
            '&.Mui-disabled': {
              backgroundColor: '#f3f4f6',
              color: '#9ca3af'
            }
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Badge
              badgeContent={totalItems}
              color="primary"
              sx={{
                '& .MuiBadge-badge': {
                  backgroundColor: 'white',
                  color: viewCartBg,
                  fontWeight: 900,
                  fontSize: '0.7rem',
                  minWidth: '22px',
                  height: '22px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }
              }}
            >
              <ShoppingBagIcon sx={{ display: 'none' }} />
            </Badge>
            <Typography variant="body1" sx={{ fontWeight: 800, textTransform: 'uppercase' }}>
              Ver Pedido
            </Typography>
          </Box>
          <Typography variant="body1" sx={{ fontWeight: 900, fontSize: '1.1rem' }}>
            $ {totalPrice.toLocaleString()}
          </Typography>
        </Button>
      </Box>
    </Box>
  );
};

// --- COMPONENTE PRINCIPAL ---
export default function MenuDelivery() {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedVariants, setSelectedVariants] = useState({});
  const [selectedProductSectionStyles, setSelectedProductSectionStyles] = useState({});
  const [openDetailProduct, setOpenDetailProduct] = useState(false);
  const [isDescExpanded, setIsDescExpanded] = useState(false);
  const [zoomImage, setZoomImage] = useState(null);
  const [cart, setCart] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [loading, setLoading] = useState(true);
  const [menu, setMenu] = useState([]);
  const [menuConfig, setMenuConfig] = useState({ darkMode: false });
  const [filteredSections, setFilteredSections] = useState([]);

  const [showOrderReceivedAnimation, setShowOrderReceivedAnimation] = useState(false);
  const [showErrorAnimation, setShowErrorAnimation] = useState(false);
  const [messageError, setMessageError] = useState("");
  const [severity, setSeverity] = useState("error");

  const [deliveryMethod, setDeliveryMethod] = useState("delivery"); // 'delivery' | 'pickup'
  const [shopAddress, setShopAddress] = useState(null);

  const [showFloatingHeader, setShowFloatingHeader] = useState(false);
  const [isBannerVisible, setIsBannerVisible] = useState(false);
  const [bannerHasBeenShown, setBannerHasBeenShown] = useState(false);

  // Estados de Checkout Domicilio
  const [customerName, setCustomerName] = useState('');
  const [customerAddress, setCustomerAddress] = useState('');
  const [customerComplement, setCustomerComplement] = useState('');
  const [openCheckoutModal, setOpenCheckoutModal] = useState(false);
  const [shopWhatsapp, setShopWhatsapp] = useState(null);

  // Estados Ubicación (Países y Ciudad con autocomplete)
  const [countriesApiData, setCountriesApiData] = useState([]);   // [{name, code}]
  const [selectedCountry, setSelectedCountry] = useState(null);    // {name, code}
  const [cityInputValue, setCityInputValue] = useState('');         // texto escrito por el usuario
  const [selectedCity, setSelectedCity] = useState(null);          // opción elegida {label, lat, lng}
  const [cityOptions, setCityOptions] = useState([]);               // sugerencias de Nominatim
  const [isLoadingLocation, setIsLoadingLocation] = useState(false);
  const [isLoadingCities, setIsLoadingCities] = useState(false);
  const citySearchTimer = useRef(null);

  // Estados Mapa
  const [mapCenter, setMapCenter] = useState({ lat: 4.7110, lng: -74.0721 }); // Default Bogotá
  const [markerPosition, setMarkerPosition] = useState({ lat: 4.7110, lng: -74.0721 });
  const [showMap, setShowMap] = useState(false); // el mapa solo se muestra cuando el usuario lo solicita

  // Cargar países desde nuestro propio endpoint (igual que en registro)
  useEffect(() => {
    setIsLoadingLocation(true);
    makeRequest(
      "POST",
      "users/countries",
      {},
      "application/json"
    )
      .then((data) => {
        const list = Array.isArray(data) ? data : [];
        setCountriesApiData(list);

        // Bug 2: Pre-seleccionar país actual del navegador por timezone
        try {
          const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
          // Mapa timezone → nombre de país tal como viene del backend
          const TZ_COUNTRY_MAP = {
            "America/Bogota":      "Colombia",
            "America/New_York":    "United States",
            "America/Chicago":     "United States",
            "America/Denver":      "United States",
            "America/Los_Angeles": "United States",
            "America/Mexico_City": "Mexico",
            "America/Lima":        "Peru",
            "America/Santiago":    "Chile",
            "America/Caracas":     "Venezuela",
            "America/Buenos_Aires":"Argentina",
            "America/Argentina/Buenos_Aires": "Argentina",
            "America/Guayaquil":   "Ecuador",
            "America/La_Paz":      "Bolivia",
            "America/Asuncion":    "Paraguay",
            "America/Montevideo":  "Uruguay",
            "America/Panama":      "Panama",
            "America/Costa_Rica":  "Costa Rica",
            "America/Guatemala":   "Guatemala",
            "America/El_Salvador": "El Salvador",
            "America/Tegucigalpa": "Honduras",
            "America/Managua":     "Nicaragua",
            "America/Santo_Domingo": "Dominican Republic",
            "America/Havana":      "Cuba",
            "America/Puerto_Rico": "Puerto Rico",
            "America/Jamaica":     "Jamaica",
            "Europe/Madrid":       "Spain",
            "Europe/London":       "United Kingdom",
            "Europe/Berlin":       "Germany",
            "Europe/Paris":        "France",
            "America/Sao_Paulo":   "Brazil",
            "America/Manaus":      "Brazil",
          };
          const countryName = TZ_COUNTRY_MAP[tz];
          if (countryName) {
            const found = list.find(
              (c) => c.name.toLowerCase() === countryName.toLowerCase()
            );
            if (found) setSelectedCountry(found);
          }
        } catch (_) {}
      })
      .catch(() => {})
      .finally(() => setIsLoadingLocation(false));
  }, []);

  // Cuando el usuario escribe en el campo de ciudad, buscamos en Nominatim con debounce
  useEffect(() => {
    if (!cityInputValue || cityInputValue.length < 2 || !selectedCountry) {
      setCityOptions([]);
      return;
    }

    // Cancelar búsqueda anterior
    if (citySearchTimer.current) clearTimeout(citySearchTimer.current);

    citySearchTimer.current = setTimeout(() => {
      setIsLoadingCities(true);
      const query = encodeURIComponent(cityInputValue);
      const cc = selectedCountry.code; // código ISO 2 (ej: 'co')
      fetch(
        `https://nominatim.openstreetmap.org/search?q=${query}&countrycodes=${cc}&format=json&limit=8&addressdetails=1`,
        { headers: { 'Accept-Language': 'es' } }
      )
        .then(res => res.json())
        .then(results => {
          const options = results
            .filter(r => ['city', 'town', 'village', 'municipality', 'suburb', 'administrative', 'county'].includes(r.type) ||
              ['city', 'town', 'village', 'municipality', 'suburb', 'administrative', 'county'].includes(r.addresstype))
            .map(r => ({
              label: r.display_name,
              shortName: r.name,
              lat: parseFloat(r.lat),
              lng: parseFloat(r.lon),
            }));
          setCityOptions(options);
        })
        .catch(err => console.warn('Error buscando ciudades:', err))
        .finally(() => setIsLoadingCities(false));
    }, 350); // debounce 350ms para respetar política de Nominatim

    return () => {
      if (citySearchTimer.current) clearTimeout(citySearchTimer.current);
    };
  }, [cityInputValue, selectedCountry]);

  const handleCountryChange = (_, newValue) => {
    setSelectedCountry(newValue);
    setSelectedCity(null);
    setCityInputValue('');
    setCityOptions([]);
    setShowMap(false); // resetear mapa al cambiar el país
  };

  const handleCityChange = (_, newValue) => {
    setSelectedCity(newValue);
    setShowMap(false); // resetear mapa si cambia la ciudad
    if (newValue) {
      // Nominatim ya nos da las coordenadas: actualizar centro para cuando se abra el mapa
      const pos = { lat: newValue.lat, lng: newValue.lng };
      setMapCenter(pos);
      setMarkerPosition(pos);
    }
  };


  const sectionRefs = useRef({});
  const headerRef = useRef(null);
  const ticking = useRef(false);
  const { restaurant_id } = useParams();

  // Scroll optimizado con requestAnimationFrame
  useEffect(() => {
    const handleScroll = () => {
      if (!ticking.current) {
        window.requestAnimationFrame(() => {
          if (headerRef.current) {
            const headerBottom = headerRef.current.getBoundingClientRect().bottom;
            setShowFloatingHeader(headerBottom < 10);
          }
          ticking.current = false;
        });
        ticking.current = true;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionName) => {
    if (sectionName === "Todo el menú") {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    const sectionElement = sectionRefs.current[sectionName];
    if (sectionElement) {
      const offset = 160;
      const elementPosition = sectionElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  const fetchMenu = useCallback(async () => {
    try {
      const menuPromise = makeRequest(
        "POST",
        `menu_manager/public_menu?restaurant_id=${restaurant_id || "3test"}`,
        {},
        "application/json"
      );

      const contactPromise = makeRequest(
        "GET",
        `restaurant_admin/public/contact_info/${restaurant_id || "3test"}`,
        null,
        "application/json"
      );

      const [menuResult, contactResult] = await Promise.allSettled([menuPromise, contactPromise]);

      if (menuResult.status === "rejected") {
        throw menuResult.reason;
      }

      const response = menuResult.value;

      const sections = response.menu.sections || [];
      sections.sort((a, b) => (a.order || 0) - (b.order || 0));

      setMenu(response);
      setFilteredSections(sections);
      localStorage.setItem("public_id", response.restaurant_public_id);

      if (response.menu) {
        const bgColor = response.menu.background_color;
        const darkMode = bgColor ? (() => {
          const luma = (() => {
            const c = bgColor.substring(1);
            const rgb = parseInt(c, 16);
            const r = (rgb >> 16) & 0xff;
            const g = (rgb >> 8) & 0xff;
            const b = (rgb >> 0) & 0xff;
            return 0.2126 * r + 0.7152 * g + 0.0722 * b;
          })();
          return luma < 128;
        })() : false;

        setMenuConfig({
          header: response.menu.header_config || {},
          tableCode: response.menu.table_code_config || {},
          filter: response.menu.filter_config || {},
          footer: response.menu.footer_config || {},
          globalBackground: response.menu.background_color || '#f9fafb',
          globalButtons: response.menu.buttons_color || '#C5A059',
          productBackground: response.menu.product_background_color,
          productText: response.menu.product_text_color,
          sections: response.menu.sections || [],
          logoUrl: response.menu.logo_url,
          backgroundImageUrl: response.menu.background_image_url,
          promotionalBannerUrl: response.menu.promotional_banner_image_url,
          themeId: response.menu.theme_id || null,
          darkMode
        });
      }

      if (contactResult.status === "fulfilled" && contactResult.value) {
        const contactData = contactResult.value;
        if (contactData.whatsapp_phone) setShopWhatsapp(contactData.whatsapp_phone);
        if (contactData.address) setShopAddress(contactData.address);
        if (contactData.google_analytics_measurement_id) {
            initGoogleAnalytics(contactData.google_analytics_measurement_id);
        }
      } else if (contactResult.status === "rejected") {
        console.error("Error fetching contact info:", contactResult.reason);
      }

      setMessageError("");
    } catch (err) {
      console.error("Error fetching menu:", err);
      setMessageError("No pudimos cargar el menú en este momento.");
      setSeverity("error");
    }
  }, [restaurant_id]);

  // Carga inicial del menú
  useEffect(() => {
    setLoading(true);
    fetchMenu().finally(() => setLoading(false));
  }, [fetchMenu]);

  // Mostrar Banner Promocional
  useEffect(() => {
    if (!loading && menuConfig?.promotionalBannerUrl && !bannerHasBeenShown) {
      const timer = setTimeout(() => {
         setIsBannerVisible(true);
         setBannerHasBeenShown(true);
      }, 500); // Pequeño retraso para que se vea natural después de cargar
      return () => clearTimeout(timer);
    }
  }, [loading, menuConfig?.promotionalBannerUrl, bannerHasBeenShown]);

  // Ajuste dinámico de fondo del body para evitar barras blancas en móviles y overscroll
  useEffect(() => {
    if (menuConfig.themeId) {
      const originalBg = document.body.style.backgroundColor;
      document.body.style.backgroundColor = '#00051e';
      return () => {
        document.body.style.backgroundColor = originalBg;
      };
    }
  }, [menuConfig.themeId]);

  const addToCart = (product) => {
    const basePrice = product.discounted_price ? product.discounted_price : product.price;
    let extraPrice = 0;
    let variantString = "";
    let selected_detail_variants = [];

    if (product.is_complex && product.detail_variants) {
      const parts = [];
      Object.keys(selectedVariants).forEach(key => {
        const qty = selectedVariants[key];
        if (qty > 0) {
          const [gIdx, oIdx] = key.split('_');
          const groupName = product.detail_variants[gIdx]?.option_display_name;
          const option = product.detail_variants[gIdx]?.details[oIdx];
          if (option) {
            // Bug 3: solo nombre y cantidad, sin precios
            const optionText = `${qty}x ${option.name}`;
            parts.push(`${groupName}: ${optionText}`);

            // Estructura interna de variants (sin precio expuesto al mensaje)
            let existingGroup = selected_detail_variants.find(g => g.option_display_name === groupName);
            if (!existingGroup) {
              existingGroup = { option_display_name: groupName, details: [] };
              selected_detail_variants.push(existingGroup);
            }
            existingGroup.details.push({ ...option, quantity: qty });
          }
        }
      });
      variantString = parts.length > 0 ? parts.join(" | ") : "";
    }

    const finalPrice = basePrice + extraPrice;
    const id = product.product_id || product.id;
    const activeVariants = Object.entries(selectedVariants).filter(([k, v]) => v > 0).sort();
    const cartItemId = product.is_complex
      ? `${id}_${activeVariants.map(([k, v]) => `${k}-${v}`).join("_")}`
      : id;

    let productSectionStyles = {};
    let buttonColorCards = menuConfig.globalButtons || '#C5A059';
    let backgroundColorCards = menuConfig.productBackground || (menuConfig.darkMode ? "#1E1E1E" : "#FFFFFF");
    let textColorCards = menuConfig.productText || (menuConfig.darkMode ? "#FFFFFF" : "#1A1A1A");
    let borderColor = productSectionStyles.product_border_color || menuConfig.globalButtons || '#C5A059';

    filteredSections.forEach(section => {
      const foundProduct = section.products.find(p =>
        p.product_id === id || p.id === id
      );
      if (foundProduct) {
        productSectionStyles = section.styles || {};
        buttonColorCards = section.button_color_cards || productSectionStyles.buttons_color || buttonColorCards;
        backgroundColorCards = section.background_color_cards || productSectionStyles.product_background_color || backgroundColorCards;
        textColorCards = section.text_color_cards || productSectionStyles.product_text_color || textColorCards;
        borderColor = productSectionStyles.product_border_color || borderColor;
      }
    });

    setCart((prev) => {
      const exists = prev.find(i => i.cartItemId === cartItemId);

      if (exists) {
        return prev.map(i =>
          i.cartItemId === cartItemId
            ? {
              ...i,
              quantity: i.quantity + quantity,
              sectionStyles: productSectionStyles,
              buttonColorCards,
              backgroundColorCards,
              textColorCards,
              borderColor
            }
            : i
        );
      }

      return [...prev, {
        ...product,
        product_id: id,
        cartItemId: cartItemId,
        variantString: variantString,
        detail_variants: selected_detail_variants,
        quantity,
        price: finalPrice,
        sectionStyles: productSectionStyles,
        buttonColorCards,
        backgroundColorCards,
        textColorCards,
        borderColor
      }];
    });

    setOpenDetailProduct(false);
    setQuantity(1);
    setSelectedVariants({});
  };


  const getUserLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          setMarkerPosition({ lat, lng });
          setMapCenter({ lat, lng });
        },
        (error) => {
          setSeverity("warning");
          setMessageError("No se pudo obtener tu ubicación automática. Por favor mueve el pin manualmente.");
          setShowErrorAnimation(true);
        }
      );
    }
  };

  // Función para manejar el envío de una orden (desde el carrito)
  const handleOrderCall = () => {
    let message = "";
    
    if (deliveryMethod === "delivery") {
      message = `*¡Hola!* 🛵 Deseo realizar el siguiente pedido a domicilio:\n`;
      message += `*Nombre:* ${customerName}\n`;
      if (selectedCountry) message += `*País:* ${selectedCountry.name}\n`;
      if (selectedCity) message += `*Ciudad:* ${selectedCity.shortName}\n`;
      message += `*Nomenclatura (Dirección):* ${customerAddress}\n`;
      if (customerComplement) message += `*Complemento:* ${customerComplement}\n`;
      message += `*Ubicación Exacta:* https://www.google.com/maps?q=${markerPosition.lat},${markerPosition.lng}\n\n`;
    } else {
      message = `*¡Hola!* 🏪 Pedido para recoger:\n`;
      message += `*Nombre:* ${customerName}\n`;
      message += `*Resumen del Pedido:*\n`;
    }

    cart.forEach(item => {
      // Bug 3: Solo nombre y cantidades, SIN precios
      message += `- ${item.quantity}x ${item.name}`;
      if (item.is_complex && item.variantString) {
        message += ` (${item.variantString})`;
      }
      message += `\n`;
    });

    if (deliveryMethod === "pickup") {
      message += `\n✅ El cliente pasará a recoger el pedido al local.\n`;
    }

    if (shopWhatsapp) {
      // Formatear el número (eliminar espacios, signos, ceros iniciales si no aplican, etc. Idealmente solo caracteres numéricos)
      const cleanPhone = shopWhatsapp.replace(/[^0-9]/g, '');
      const waUrl = `https://wa.me/${cleanPhone}?text=${encodeURIComponent(message)}`;
      window.open(waUrl, '_blank');
    } else {
      setMessageError("El restaurante no ha configurado una línea de atención.");
      setSeverity("error");
      setShowErrorAnimation(true);
      return;
    }

    setShowOrderReceivedAnimation(true);
    setCart([]); // Vaciar carrito tras orden exitosa
    setIsCartOpen(false);
    setOpenCheckoutModal(false);
    setCustomerName('');
    setCustomerAddress('');
  };

  const handleProductSelect = (product, section) => {
    setSelectedProduct(product);
    setSelectedVariants({});
    setSelectedProductSectionStyles({
      sectionStyles: section.styles || {},
      buttonColorCards: section.button_color_cards,
      backgroundColorCards: section.background_color_cards,
      textColorCards: section.text_color_cards,
      borderColor: section.styles?.product_border_color
    });
    setOpenDetailProduct(true);
    setIsDescExpanded(false);
    setQuantity(1);
    setZoomImage(null);
  };


  // Lógica de cálculo de precios en tiempo real para variantes
  const getBasePrice = () => {
    if (!selectedProduct) return 0;
    return selectedProduct.discounted_price ? selectedProduct.discounted_price : selectedProduct.price;
  };

  const getVariantsExtraPrice = () => {
    if (!selectedProduct || !selectedProduct.is_complex || !selectedProduct.detail_variants) return 0;
    let extra = 0;
    Object.keys(selectedVariants).forEach(key => {
      const qty = selectedVariants[key];
      if (qty > 0) {
        const [gIdx, oIdx] = key.split('_');
        const option = selectedProduct.detail_variants[gIdx]?.details[oIdx];
        if (option && option.value) {
          extra += Number(option.value) * qty;
        }
      }
    });
    return extra;
  };

  const finalUnitPrice = getBasePrice() + getVariantsExtraPrice();
  // En este formato multisexual por cantitades, no hay bloqueo de confirmación mandatorio
  const isComplexReady = true;

  // --- RENDERIZADO CONDICIONAL ---
  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <CircularProgress sx={{ color: "#C5A059" }} />
      </Box>
    );
  }

  if (messageError && filteredSections.length === 0) {
    return (
      <Box sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        px: 4,
        textAlign: 'center',
        backgroundColor: '#f9fafb'
      }}>
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#333' }}>
          {messageError}
        </Typography>
        <Button
          variant="contained"
          onClick={fetchMenu}
          sx={{
            backgroundColor: '#C5A059',
            color: '#ffffff',
            fontWeight: 700,
            py: 1.5,
            borderRadius: '12px',
            textTransform: 'none',
            fontSize: '1rem',
            boxShadow: '0 4px 12px rgba(197, 160, 89, 0.3)',
            '&:hover': { backgroundColor: '#B38E42' },
            px: 4
          }}
        >
          Reintentar cargar menú
        </Button>
      </Box>
    );
  }

  // Renderizado normal del menú
  return (
    <Box sx={{
      position: 'relative',
      minHeight: '100vh',
      backgroundColor: menuConfig.themeId ? '#00051e' : 'transparent'
    }}>
      {/* Imagen de fondo con blur (si existe) */}
      {menuConfig.backgroundImageUrl && (
        <Box sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url(${menuConfig.backgroundImageUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          transform: 'scale(1.02)',
          zIndex: -1,
        }} />
      )}

      {/* Contenido principal con overlay semitransparente si hay imagen */}
      <Box sx={{
        position: 'relative',
        zIndex: 1,
        // World Cup theme handles its own background — use dark stadium blue to blend and avoid white bars
        backgroundColor: menuConfig.themeId
          ? '#00051e'
          : menuConfig.backgroundImageUrl
            ? 'rgba(0,0,0,0.2)'
            : (menuConfig.darkMode ? "#121212" : "#FDFCFB"),
        minHeight: '100vh',
        pb: menuConfig.themeId ? 0 : '90px',
      }}>
        {menuConfig.themeId && worldCupThemeAssets[menuConfig.themeId] ? (
          <>
            <WorldCupRenderer
              sections={filteredSections}
              theme={worldCupThemeAssets[menuConfig.themeId]}
              logoUrl={menuConfig.logoUrl}
              restaurantName={menu.restaurant_name}
              onProductSelect={handleProductSelect}
            />
            <MenuFooter
              cart={cart}
              onOpenCart={() => setIsCartOpen(true)}
              menuConfig={{
                ...menuConfig,
                productBackground: worldCupThemeAssets[menuConfig.themeId].secondary,
                footer: {
                  ...menuConfig.footer,
                  view_cart_button_background: worldCupThemeAssets[menuConfig.themeId].primary,
                  view_cart_button_text_color: '#FFFFFF'
                }
              }}
            />
          </>
        ) : (
          <>
            {/* Placeholder para mini header */}
            {showFloatingHeader && <Box sx={{ height: '70px' }} />}

            {/* Header principal */}
            <div ref={headerRef}>
              <MenuHeader
                menuSections={menu.menu?.sections || []}
                sessionCode={null}
                onScrollToSection={scrollToSection}
                menuConfig={menuConfig}
                logoUrl={menuConfig.logoUrl}
                nameMenu={menu.restaurant_name}
              />
            </div>

            {/* Mini header flotante */}
            <MiniHeader
              menuSections={menu.menu?.sections || []}
              onScrollToSection={scrollToSection}
              menuConfig={menuConfig}
              show={showFloatingHeader}
            />

            <Container maxWidth="md" sx={{ mt: 3 }}>
              {filteredSections.map((section, idx) => (
                <Box
                  key={idx}
                  ref={(el) => (sectionRefs.current[section.name] = el)}
                >
                  <MenuSection
                    section={section}
                    onProductSelect={handleProductSelect}
                    isDarkMode={menuConfig.darkMode}
                    globalButtonColor={menuConfig.globalButtons}
                  />
                </Box>
              ))}
            </Container>

            <MenuFooter
              cart={cart}
              onOpenCart={() => setIsCartOpen(true)}
              menuConfig={menuConfig}
            />
          </>
        )}

        {/* Modal de detalle de producto */}
        {menuConfig.themeId && worldCupThemeAssets[menuConfig.themeId] ? (
          <WorldCupProductModal
            open={openDetailProduct}
            onClose={() => setOpenDetailProduct(false)}
            product={selectedProduct}
            theme={worldCupThemeAssets[menuConfig.themeId]}
            quantity={quantity}
            setQuantity={setQuantity}
            selectedVariants={selectedVariants}
            setSelectedVariants={setSelectedVariants}
            onAddToCart={addToCart}
          />
        ) : (
        <Dialog
          open={openDetailProduct}
          onClose={() => setOpenDetailProduct(false)}
          fullWidth
          maxWidth="xs"
          PaperProps={{
            sx: {
              borderRadius: '28px',
              overflow: 'hidden',
              backgroundColor: menuConfig.darkMode ? '#1A1A1A' : '#FFFFFF',
              maxWidth: '500px !important',
              width: '95%',
              margin: 'auto',
              boxShadow: '0 24px 60px rgba(0,0,0,0.25)',
            },
          }}
        >
          {/* ---- HERO: imagen o gradiente con nombre y precio ---- */}
          <Box sx={{ position: 'relative' }}>
            {selectedProduct?.image_url ? (
              <Box 
                onClick={() => selectedProduct.image_url && setZoomImage(selectedProduct.image_url)}
                sx={{ 
                  width: '100%', 
                  height: '220px', 
                  overflow: 'hidden',
                  cursor: selectedProduct.image_url ? 'pointer' : 'default'
                }}
              >
                <img
                  src={selectedProduct.image_url}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  alt={selectedProduct?.name}
                />
                {/* Gradiente oscuro sobre la imagen */}
                <Box sx={{
                  position: 'absolute', inset: 0,
                  background: 'linear-gradient(to top, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.1) 60%)',
                }} />
              </Box>
            ) : (
              <Box sx={{
                width: '100%', height: '140px',
                background: `linear-gradient(135deg, ${selectedProductSectionStyles.buttonColorCards || menuConfig.globalButtons || '#C5A059'}22, ${selectedProductSectionStyles.buttonColorCards || menuConfig.globalButtons || '#C5A059'}55)`,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <RestaurantMenuIcon sx={{ fontSize: 56, color: selectedProductSectionStyles.buttonColorCards || menuConfig.globalButtons || '#C5A059', opacity: 0.6 }} />
              </Box>
            )}

            {/* Nombre y precio sobre el hero */}
            <Box sx={{
              position: 'absolute', bottom: 0, left: 0, right: 0,
              px: 2.5, pb: selectedProduct?.image_url ? 2 : 1.5, pt: 1,
            }}>
              <Typography variant="h5" sx={{
                fontWeight: 900, lineHeight: 1.2,
                color: selectedProduct?.image_url
                  ? '#FFFFFF'
                  : (selectedProductSectionStyles.textColorCards || menuConfig.productText || (menuConfig.darkMode ? '#FFF' : '#1A1A1A')),
                textShadow: selectedProduct?.image_url ? '0 2px 8px rgba(0,0,0,0.5)' : 'none',
              }}>
                {selectedProduct?.name}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                <Typography variant="h6" sx={{
                  fontWeight: 900,
                  color: selectedProduct?.image_url ? '#FFD97D' : (selectedProductSectionStyles.buttonColorCards || menuConfig.globalButtons || '#C5A059'),
                  fontSize: '1.1rem',
                }}>
                  ${(selectedProduct?.discounted_price || selectedProduct?.price || 0).toLocaleString()}
                </Typography>
                {selectedProduct?.discounted_price && (
                  <Typography variant="caption" sx={{
                    textDecoration: 'line-through',
                    color: selectedProduct?.image_url ? 'rgba(255,255,255,0.6)' : '#aaa',
                    fontWeight: 600,
                  }}>
                    ${(selectedProduct?.price || 0).toLocaleString()}
                  </Typography>
                )}
              </Box>
            </Box>

            {/* Botón cerrar */}
            <IconButton
              onClick={() => setOpenDetailProduct(false)}
              sx={{
                position: 'absolute', right: 10, top: 10,
                color: '#ffffff', bgcolor: 'rgba(0,0,0,0.35)',
                backdropFilter: 'blur(8px)', zIndex: 10,
                '&:hover': { bgcolor: 'rgba(0,0,0,0.55)' },
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <DialogContent sx={{
            p: 0,
            display: 'flex',
            flexDirection: 'column',
            maxHeight: '60vh',
            overflowY: 'auto',
          }}>
            {/* Descripción */}
            {selectedProduct?.description && (() => {
              const shouldTruncate = selectedProduct.description.length > 150;
              const displayText = isDescExpanded
                ? selectedProduct.description
                : shouldTruncate
                  ? `${selectedProduct.description.substring(0, 150)}...`
                  : selectedProduct.description;
              return (
                <Box sx={{ px: 2.5, pt: 2, pb: selectedProduct?.is_complex ? 0 : 2 }}>
                  <Typography variant="body2" sx={{
                    color: menuConfig.darkMode ? '#CCCCCC' : '#555555',
                    lineHeight: 1.6, fontWeight: 500,
                  }}>
                    {displayText}{' '}
                    {shouldTruncate && (
                      <span
                        onClick={() => setIsDescExpanded(!isDescExpanded)}
                        style={{
                          color: selectedProductSectionStyles.buttonColorCards || menuConfig.globalButtons || '#C5A059',
                          cursor: 'pointer',
                          fontWeight: 800,
                          marginLeft: '4px',
                          textDecoration: 'underline'
                        }}
                      >
                        {isDescExpanded ? 'Ver menos' : 'Ver más'}
                      </span>
                    )}
                  </Typography>
                </Box>
              );
            })()}

            {/* ---- VARIANTES: solo para productos complejos ---- */}
            {selectedProduct?.is_complex && selectedProduct?.detail_variants && (
              <Box sx={{ px: 2.5, pt: 2, pb: 1 }}>
                {selectedProduct.detail_variants.map((group, groupIndex) => {
                  const mainColor = selectedProductSectionStyles.buttonColorCards
                    || selectedProductSectionStyles.sectionStyles?.buttons_color
                    || menuConfig.globalButtons || '#C5A059';
                  return (
                    <Box key={groupIndex} sx={{ mb: 2.5 }}>
                      {/* Cabecera del grupo */}
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                        <Box sx={{ width: 4, height: 18, borderRadius: 2, bgcolor: mainColor }} />
                        <Typography variant="subtitle2" sx={{
                          fontWeight: 800, fontSize: '0.9rem',
                          color: menuConfig.darkMode ? '#FFFFFF' : '#1A1A1A',
                          textTransform: 'uppercase', letterSpacing: '0.5px',
                        }}>
                          {group.option_display_name}
                        </Typography>
                      </Box>

                      {/* Opciones en grilla de 2 columnas */}
                      <Grid container spacing={1}>
                        {group.details.map((option, optionIndex) => {
                          const key = `${groupIndex}_${optionIndex}`;
                          const qty = selectedVariants[key] || 0;
                          const isSelected = qty > 0;
                          const hasPrice = Number(option.value || 0) > 0;

                          return (
                            <Grid item xs={6} key={optionIndex}>
                              <Box sx={{
                                border: `2px solid ${isSelected ? mainColor : (menuConfig.darkMode ? 'rgba(255,255,255,0.12)' : '#E5E7EB')}`,
                                borderRadius: '16px',
                                overflow: 'hidden',
                                backgroundColor: isSelected ? `${mainColor}12` : (menuConfig.darkMode ? 'rgba(255,255,255,0.03)' : '#FAFAFA'),
                                transition: 'all 0.18s ease',
                                cursor: 'default',
                              }}>
                                {/* Nombre y precio de la opción */}
                                <Box sx={{ px: 1.5, pt: 1.5, pb: 1 }}>
                                  <Typography sx={{
                                    fontWeight: 700, fontSize: '0.85rem',
                                    color: menuConfig.darkMode ? '#F0F0F0' : '#1A1A1A',
                                    lineHeight: 1.3,
                                  }}>
                                    {option.name}
                                  </Typography>
                                  {hasPrice && (
                                    <Typography variant="caption" sx={{
                                      fontWeight: 800, color: mainColor,
                                      display: 'block', mt: 0.3,
                                    }}>
                                      +${Number(option.value).toLocaleString()}
                                    </Typography>
                                  )}
                                </Box>

                                {/* Contador +/- */}
                                <Box sx={{
                                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                  px: 0.5, pb: 0.5,
                                  borderTop: `1px solid ${isSelected ? `${mainColor}30` : (menuConfig.darkMode ? 'rgba(255,255,255,0.06)' : '#F0F0F0')}`,
                                }}>
                                  <IconButton
                                    size="small"
                                    onClick={() => setSelectedVariants(prev => ({ ...prev, [key]: Math.max(0, (prev[key] || 0) - 1) }))}
                                    sx={{
                                      color: isSelected ? mainColor : (menuConfig.darkMode ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'),
                                      '&:active': { transform: 'scale(0.9)' },
                                    }}
                                  >
                                    <RemoveIcon sx={{ fontSize: '1rem' }} />
                                  </IconButton>
                                  <Typography sx={{
                                    fontWeight: 900, fontSize: '1rem', minWidth: '20px', textAlign: 'center',
                                    color: isSelected ? mainColor : (menuConfig.darkMode ? '#888' : '#aaa'),
                                  }}>
                                    {qty}
                                  </Typography>
                                  <IconButton
                                    size="small"
                                    onClick={() => setSelectedVariants(prev => ({ ...prev, [key]: (prev[key] || 0) + 1 }))}
                                    sx={{
                                      color: mainColor,
                                      '&:active': { transform: 'scale(0.9)' },
                                    }}
                                  >
                                    <AddIcon sx={{ fontSize: '1rem' }} />
                                  </IconButton>
                                </Box>
                              </Box>
                            </Grid>
                          );
                        })}
                      </Grid>
                    </Box>
                  );
                })}
              </Box>
            )}
          </DialogContent>

          {/* ---- BARRA INFERIOR PEGAJOSA: cantidad + botón agregar ---- */}
          <Box sx={{
            px: 2.5, py: 2,
            borderTop: `1px solid ${menuConfig.darkMode ? 'rgba(255,255,255,0.08)' : '#F0F0F0'}`,
            backgroundColor: menuConfig.darkMode ? '#1A1A1A' : '#FFFFFF',
            display: 'flex', alignItems: 'center', gap: 2,
          }}>
            {/* Selector de cantidad */}
            <Box sx={{
              display: 'flex', alignItems: 'center', gap: 0.5,
              border: `1.5px solid ${selectedProductSectionStyles.buttonColorCards || menuConfig.globalButtons || '#C5A059'}`,
              borderRadius: '14px', px: 0.5,
            }}>
              <IconButton
                size="small"
                onClick={() => setQuantity(Math.max(1, quantity - 1))}
                sx={{ color: selectedProductSectionStyles.buttonColorCards || menuConfig.globalButtons || '#C5A059', '&:active': { transform: 'scale(0.9)' } }}
              >
                <RemoveIcon fontSize="small" />
              </IconButton>
              <Typography sx={{
                fontWeight: 900, fontSize: '1.1rem', minWidth: '28px', textAlign: 'center',
                color: menuConfig.darkMode ? '#FFFFFF' : '#1A1A1A',
              }}>
                {quantity}
              </Typography>
              <IconButton
                size="small"
                onClick={() => setQuantity(quantity + 1)}
                sx={{ color: selectedProductSectionStyles.buttonColorCards || menuConfig.globalButtons || '#C5A059', '&:active': { transform: 'scale(0.9)' } }}
              >
                <AddIcon fontSize="small" />
              </IconButton>
            </Box>

            {/* Botón agregar (crece para ocupar el resto) */}
            <Button
              fullWidth
              variant="contained"
              disabled={!isComplexReady}
              onClick={() => addToCart(selectedProduct)}
              sx={{
                backgroundColor: selectedProductSectionStyles.buttonColorCards
                  || selectedProductSectionStyles.sectionStyles?.buttons_color
                  || menuConfig.globalButtons || '#C5A059',
                color: getContrastColor(selectedProductSectionStyles.buttonColorCards
                  || selectedProductSectionStyles.sectionStyles?.buttons_color
                  || menuConfig.globalButtons || '#C5A059'),
                py: 1.6, fontWeight: 800, borderRadius: '14px',
                fontSize: '1rem', textTransform: 'none',
                boxShadow: `0 6px 16px rgba(${hexToRgb(selectedProductSectionStyles.buttonColorCards || menuConfig.globalButtons || '#C5A059')}, 0.3)`,
                '&:hover': { opacity: 0.92 },
                '&.Mui-disabled': {
                  backgroundColor: menuConfig.darkMode ? 'rgba(255,255,255,0.08)' : '#E5E7EB',
                  color: menuConfig.darkMode ? 'rgba(255,255,255,0.25)' : '#9CA3AF',
                }
              }}
            >
              Agregar • ${(finalUnitPrice * quantity).toLocaleString()}
            </Button>
          </Box>
        </Dialog>
        )}

        {/* Zoom Image Dialog */}
        <Dialog 
          open={!!zoomImage} 
          onClose={() => setZoomImage(null)} 
          maxWidth="md" 
          PaperProps={{ sx: { bgcolor: 'transparent', boxShadow: 'none', overflow: 'hidden' } }}
        >
          <Box sx={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', bgcolor: 'rgba(0,0,0,0.9)', p: 1, borderRadius: '16px', border: `2px solid ${selectedProductSectionStyles.buttonColorCards || menuConfig.globalButtons || '#C5A059'}` }}>
            <img src={zoomImage} style={{ maxWidth: '100%', maxHeight: '85vh', objectFit: 'contain', borderRadius: '12px' }} alt="Zoom" />
            <IconButton
              onClick={() => setZoomImage(null)}
              sx={{ position: 'absolute', right: 15, top: 15, color: selectedProductSectionStyles.buttonColorCards || menuConfig.globalButtons || '#C5A059', bgcolor: 'rgba(0,0,0,0.7)', border: `1px solid ${selectedProductSectionStyles.buttonColorCards || menuConfig.globalButtons || '#C5A059'}`, '&:hover': { bgcolor: selectedProductSectionStyles.buttonColorCards || menuConfig.globalButtons || '#C5A059', color: '#000' } }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </Dialog>

        {/* Modales eliminados para Delivery */}



        {/* Drawer del carrito */}
        <Drawer
          anchor="right"
          open={isCartOpen}
          onClose={() => setIsCartOpen(false)}
          PaperProps={{
            sx: {
              width: { xs: '100%', sm: 420 },
              borderTopLeftRadius: '28px',
              borderBottomLeftRadius: '28px',
              backgroundColor: menuConfig.globalBackground || (menuConfig.darkMode ? "#121212" : "#FDFCFB")
            }
          }}
        >
          <Box sx={{
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            backgroundColor: menuConfig.globalBackground || (menuConfig.darkMode ? "#121212" : "#FDFCFB")
          }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
              <Typography variant="h5" fontWeight={900} sx={{
                color: menuConfig.productText || (menuConfig.darkMode ? "#FFFFFF" : "#1A1A1A")
              }}>
                Mi Pedido
              </Typography>
              <IconButton onClick={() => setIsCartOpen(false)} sx={{ color: menuConfig.globalButtons || '#C5A059' }}>
                <CloseIcon />
              </IconButton>
            </Box>

            <Divider sx={{ mb: 3, borderColor: menuConfig.darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)' }} />

            <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>
              {cart.length === 0 ? (
                <Box sx={{ textAlign: 'center', mt: 15 }}>
                  <ShoppingBagIcon sx={{ fontSize: 100, color: menuConfig.darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)', mb: 2 }} />
                  <Typography sx={{ color: menuConfig.productText || (menuConfig.darkMode ? "#FFFFFF" : "#1A1A1A"), fontWeight: 600 }}>
                    Carrito vacío
                  </Typography>
                </Box>
              ) : (
                cart.map((item) => (
                  <Box key={item.cartItemId || item.product_id} sx={{
                    display: 'flex',
                    gap: 2,
                    mb: 2.5,
                    p: 2,
                    borderRadius: '20px',
                    border: `1.5px solid ${item.borderColor || menuConfig.globalButtons || '#C5A059'}`,
                    backgroundColor: item.backgroundColorCards || (menuConfig.darkMode ? "#1E1E1E" : "#FFFFFF"),
                  }}>
                    <Box sx={{ width: 85, minWidth: 85, borderRadius: '12px', overflow: 'hidden' }}>
                      <Box sx={{ width: '100%', paddingTop: '100%', position: 'relative' }}>
                        <img
                          src={item.image_url || imagenLocal}
                          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover' }}
                          alt={item.name}
                        />
                      </Box>
                    </Box>

                    <Box sx={{ flexGrow: 1 }}>
                      <Typography variant="subtitle1" fontWeight={800} sx={{ color: item.textColorCards || (menuConfig.darkMode ? "#FFFFFF" : "#1A1A1A"), mb: 0.5 }}>
                        {item.name}
                      </Typography>

                      {item.variantString && (
                        <Typography variant="caption" sx={{ color: item.textColorCards || (menuConfig.darkMode ? "#FFFFFF" : "#1A1A1A"), opacity: 0.8, display: 'block', mb: 1, lineHeight: 1.2 }}>
                          {item.variantString}
                        </Typography>
                      )}

                      <Typography variant="body1" sx={{ color: item.buttonColorCards || menuConfig.globalButtons || '#C5A059', fontWeight: 900, mb: 0.5 }}>
                        ${(item.price * item.quantity).toLocaleString()}
                      </Typography>

                      <Typography variant="caption" sx={{ color: item.textColorCards || (menuConfig.darkMode ? "#FFFFFF" : "#1A1A1A"), opacity: 0.7, display: 'block', mb: 1 }}>
                        ${item.price.toLocaleString()} c/u
                      </Typography>

                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', bgcolor: menuConfig.darkMode ? '#333' : '#f5f5f5', borderRadius: '10px', px: 1 }}>
                          <IconButton size="small" onClick={() => setCart(cart.map(i => i.cartItemId === item.cartItemId ? { ...i, quantity: Math.max(1, i.quantity - 1) } : i))}>
                            <RemoveIcon fontSize="small" sx={{ color: item.buttonColorCards || menuConfig.globalButtons || '#C5A059' }} />
                          </IconButton>
                          <Typography sx={{ mx: 1.5, fontWeight: 900, color: item.textColorCards || (menuConfig.darkMode ? "#FFFFFF" : "#1A1A1A") }}>
                            {item.quantity}
                          </Typography>
                          <IconButton size="small" onClick={() => setCart(cart.map(i => i.cartItemId === item.cartItemId ? { ...i, quantity: i.quantity + 1 } : i))}>
                            <AddIcon fontSize="small" sx={{ color: item.buttonColorCards || menuConfig.globalButtons || '#C5A059' }} />
                          </IconButton>
                        </Box>
                        <IconButton size="small" onClick={() => setCart(cart.filter(i => i.cartItemId !== item.cartItemId))}>
                          <DeleteOutlineIcon fontSize="small" sx={{ color: item.buttonColorCards || menuConfig.globalButtons || '#C5A059' }} />
                        </IconButton>
                      </Box>
                    </Box>
                  </Box>
                ))
              )}
            </Box>

            {cart.length > 0 && (
              <Box sx={{ mt: 'auto', pt: 3 }}>
                <Divider sx={{ mb: 2.5, borderColor: menuConfig.darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)' }} />
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 4 }}>
                  <Typography variant="h5" fontWeight={700} sx={{ color: menuConfig.productText || (menuConfig.darkMode ? "#FFFFFF" : "#1A1A1A") }}>
                    Total
                  </Typography>
                  <Typography variant="h5" fontWeight={900} sx={{ color: menuConfig.globalButtons || '#C5A059' }}>
                    ${cart.reduce((acc, curr) => acc + (curr.price * curr.quantity), 0).toLocaleString()}
                  </Typography>
                </Box>

                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => setOpenCheckoutModal(true)}
                  sx={{
                    backgroundColor: menuConfig.footer?.view_cart_button_background || '#C5A059',
                    color: getContrastColor(menuConfig.footer?.view_cart_button_background || '#C5A059'),
                    py: 2.2,
                    borderRadius: '18px',
                    fontWeight: 900,
                    fontSize: '1.1rem',
                    boxShadow: `0 8px 20px rgba(${hexToRgb(menuConfig.footer?.view_cart_button_background || '#C5A059')}, 0.25)`,
                    '&:hover': { opacity: 0.9 }
                  }}
                >
                  Continuar
                </Button>

                <Typography variant="caption" sx={{ mt: 2, textAlign: 'center', display: 'block', color: menuConfig.darkMode ? '#aaa' : '#666', fontWeight: 500 }}>
                  Completa tus datos para confirmar
                </Typography>
              </Box>
            )}
          </Box>
        </Drawer>

        <Snackbar open={showOrderReceivedAnimation} autoHideDuration={2000} onClose={() => setShowOrderReceivedAnimation(false)}>
          <Alert severity="success" variant="filled" action={<IconButton size="small" color="inherit" onClick={() => setShowOrderReceivedAnimation(false)}><CloseIcon fontSize="small" /></IconButton>}>
            ¡Llamado enviado!
          </Alert>
        </Snackbar>

        <Snackbar open={showErrorAnimation} autoHideDuration={2000} onClose={() => setShowErrorAnimation(false)}>
          <Alert severity={severity} variant="filled" action={<IconButton size="small" color="inherit" onClick={() => setShowErrorAnimation(false)}><CloseIcon fontSize="small" /></IconButton>}>
            {messageError}
          </Alert>
        </Snackbar>

        <CustomDialog open={openCheckoutModal} onClose={() => setOpenCheckoutModal(false)}>
          <CustomDialogTitle sx={{ textAlign: 'center', color: '#000000', fontWeight: 700 }}>
            🛵 Datos de Envío
          </CustomDialogTitle>
          <CustomDialogContent>
            <DialogContentText sx={{ textAlign: 'center', mb: 3, color: '#333333', fontWeight: 600 }}>
              Por favor, dinos a dónde enviamos tu pedido y a nombre de quién.
            </DialogContentText>

            <TextField
              label="Tu Nombre"
              fullWidth
              value={customerName}
              onChange={(e) => setCustomerName(e.target.value)}
              variant="outlined"
              sx={{ mb: 3, "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
            />

            {shopWhatsapp && (
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
                <ToggleButtonGroup
                  color="primary"
                  value={deliveryMethod}
                  exclusive
                  onChange={(e, newAlignment) => {
                    if (newAlignment !== null) setDeliveryMethod(newAlignment);
                  }}
                  aria-label="Método de entrega"
                  sx={{ width: '100%' }}
                >
                  <ToggleButton 
                    value="delivery" 
                    sx={{ 
                      flex: 1, borderRadius: '12px 0 0 12px', fontWeight: 600, textTransform: 'none',
                      borderColor: menuConfig.globalButtons || '#C5A059',
                      color: deliveryMethod === 'delivery' ? '#fff' : (menuConfig.globalButtons || '#C5A059'),
                      '&.Mui-selected': { bgcolor: menuConfig.globalButtons || '#C5A059', color: '#fff', '&:hover': { bgcolor: menuConfig.globalButtons || '#C5A059' } }
                    }}
                  >
                    🚚 Domicilio
                  </ToggleButton>
                  <ToggleButton 
                    value="pickup" 
                    sx={{ 
                      flex: 1, borderRadius: '0 12px 12px 0', fontWeight: 600, textTransform: 'none',
                      borderColor: menuConfig.globalButtons || '#C5A059',
                      color: deliveryMethod === 'pickup' ? '#fff' : (menuConfig.globalButtons || '#C5A059'),
                      '&.Mui-selected': { bgcolor: menuConfig.globalButtons || '#C5A059', color: '#fff', '&:hover': { bgcolor: menuConfig.globalButtons || '#C5A059' } }
                    }}
                  >
                    🏪 Recoger en local
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>
            )}

            {deliveryMethod === 'pickup' && shopAddress && (
              <Alert severity="info" sx={{ mb: 3, borderRadius: '12px' }}>
                📍 Recoge tu pedido en: <strong>{shopAddress}</strong>
              </Alert>
            )}

            {deliveryMethod === 'delivery' && (
              <>
                <Grid container spacing={2} sx={{ mb: 2 }}>

              {/* PAÍS: selector con Autocomplete (REST Countries) */}
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  options={countriesApiData}
                  getOptionLabel={(option) => `${option.name} (${option.code})`}
                  value={selectedCountry}
                  onChange={handleCountryChange}
                  loading={isLoadingLocation}
                  loadingText="Cargando países..."
                  noOptionsText="No encontrado"
                  isOptionEqualToValue={(opt, val) => opt.id === val.id}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      {...props}
                      key={option.id}
                      sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}
                    >
                      <Avatar
                        src={option.flag}
                        alt={option.name}
                        sx={{ width: 24, height: 24, flexShrink: 0, border: '1px solid #e2e8f0' }}
                      />
                      <span style={{ fontSize: '14px', fontWeight: 500 }}>
                        {option.name} <span style={{ color: '#94a3b8', fontSize: '12px' }}>({option.code})</span>
                      </span>
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="País"
                      variant="outlined"
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: selectedCountry?.flag ? (
                          <Avatar
                            src={selectedCountry.flag}
                            alt={selectedCountry.name}
                            sx={{ width: 20, height: 20, mr: 0.5, ml: 0.5, border: '1px solid #e2e8f0' }}
                          />
                        ) : null,
                        endAdornment: (
                          <>
                            {isLoadingLocation ? <CircularProgress color="inherit" size={18} /> : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>

              {/* CIUDAD: autocomplete con búsqueda en Nominatim */}
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  options={cityOptions}
                  getOptionLabel={(option) => option.label || ''}
                  filterOptions={(x) => x}  // desactivar filtro local: Nominatim ya filtra
                  value={selectedCity}
                  inputValue={cityInputValue}
                  onInputChange={(_, newInput) => setCityInputValue(newInput)}
                  onChange={handleCityChange}
                  loading={isLoadingCities}
                  loadingText="Buscando..."
                  noOptionsText={!selectedCountry ? 'Primero elige un país' : cityInputValue.length < 2 ? 'Escribe al menos 2 letras' : 'Sin resultados'}
                  disabled={!selectedCountry}
                  isOptionEqualToValue={(opt, val) => opt.label === val.label}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Ciudad / Municipio"
                      variant="outlined"
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {isLoadingCities ? <CircularProgress color="inherit" size={18} /> : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>

            <TextField
              label="Nomenclatura (Ej: Calle 123 #45-67)"
              fullWidth
              value={customerAddress}
              onChange={(e) => setCustomerAddress(e.target.value)}
              variant="outlined"
              sx={{ mb: 2, "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
            />

            <TextField
              label="Complemento (Opcional, Ej: Apto 101, Torre 2)"
              fullWidth
              value={customerComplement}
              onChange={(e) => setCustomerComplement(e.target.value)}
              variant="outlined"
              sx={{ mb: 3, "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
            />

            {/* Sección del mapa: se muestra solo cuando el usuario lo solicita con país + ciudad elegidos */}
            {!showMap ? (
              <Box sx={{ mb: 2 }}>
                <Button
                  fullWidth
                  variant="outlined"
                  disabled={!selectedCountry || !selectedCity}
                  onClick={() => setShowMap(true)}
                  startIcon={<MyLocationIcon />}
                  sx={{
                    borderRadius: '12px',
                    py: 1.5,
                    fontWeight: 700,
                    textTransform: 'none',
                    fontSize: '0.95rem',
                    borderColor: (!selectedCountry || !selectedCity) ? '#ccc' : (menuConfig.globalButtons || '#C5A059'),
                    color: (!selectedCountry || !selectedCity) ? '#aaa' : (menuConfig.globalButtons || '#C5A059'),
                    borderWidth: '2px',
                    '&:hover': {
                      borderWidth: '2px',
                      borderColor: menuConfig.globalButtons || '#C5A059',
                      backgroundColor: `${menuConfig.globalButtons || '#C5A059'}10`,
                    },
                    '&.Mui-disabled': {
                      borderWidth: '2px',
                    }
                  }}
                >
                  {(!selectedCountry || !selectedCity)
                    ? 'Primero elige país y ciudad para usar el mapa'
                    : `(Opcional) Ubicar en el Mapa`}
                </Button>
                {(!selectedCountry || !selectedCity) && (
                  <Typography variant="caption" sx={{ display: 'block', textAlign: 'center', mt: 0.5, color: '#999' }}>
                    Elige el país y ciudad primero
                  </Typography>
                )}
              </Box>
            ) : (
              <Box sx={{ mb: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                  <Typography variant="subtitle2" fontWeight={700} sx={{ color: '#333' }}>
                    📍 Ubicación exacta en {selectedCity?.shortName}
                  </Typography>
                  <Button
                    size="small"
                    startIcon={<MyLocationIcon />}
                    onClick={getUserLocation}
                    sx={{ textTransform: 'none', fontWeight: 600, color: menuConfig.globalButtons || '#C5A059' }}
                  >
                    Mi GPS
                  </Button>
                </Box>
                <Box sx={{ width: '100%', height: '280px', borderRadius: '14px', overflow: 'hidden', border: `2px solid ${menuConfig.globalButtons || '#C5A059'}40`, mb: 1 }}>
                  <AddressMapSelector
                    position={markerPosition}
                    center={mapCenter}
                    onPositionChange={(pos) => {
                      setMarkerPosition(pos);
                      setMapCenter(pos);
                    }}
                  />
                </Box>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', textAlign: 'center' }}>
                  Haz clic en el mapa o arrastra el pin para ajustar tu ubicación exacta.
                </Typography>
              </Box>
            )}
            </>
            )}

          </CustomDialogContent>
          <CustomDialogActions sx={{ justifyContent: 'center', gap: 2, pb: 3 }}>
            <Button
              onClick={() => setOpenCheckoutModal(false)}
              variant="outlined"
              sx={{
                borderColor: menuConfig.globalButtons || '#C5A059',
                color: menuConfig.globalButtons || '#C5A059',
                px: 4,
                py: 1.2,
                fontWeight: 700,
                borderRadius: '12px',
                '&:hover': {
                  borderColor: '#000',
                  color: '#000'
                }
              }}
            >
              Cancelar
            </Button>
            <Button
              onClick={handleOrderCall}
              variant="contained"
              disabled={
                !customerName.trim() || 
                (deliveryMethod === 'delivery' && (!customerAddress.trim() || !selectedCountry || !selectedCity))
              }
              sx={{
                backgroundColor: menuConfig.globalButtons || '#C5A059',
                color: getContrastColor(menuConfig.globalButtons || '#C5A059'),
                px: 4,
                py: 1.2,
                fontWeight: 700,
                borderRadius: '12px',
                '&:hover': { opacity: 0.9 }
              }}
            >
              Confirmar Pedido
            </Button>
          </CustomDialogActions>
        </CustomDialog>
        
        <PromotionalBannerModal 
          imageUrl={menuConfig?.promotionalBannerUrl}
          isVisible={isBannerVisible}
          onClose={() => setIsBannerVisible(false)}
        />
      </Box>
    </Box>
  );
}

